import ChangePasswordForm from '@/components/settings/change-password';
import PrimaryEmail from '@/components/settings/primary-email';
import RecoveryEmail from '@/components/settings/recovery-email';
import UserData from '@/components/settings/user-data';
import { Separator } from '@/components/ui/separator';
import { AsyncErrorBoundary } from '@/context/async-error-boundary';
import { useAuthContext } from '@/context/auth-provider';
import { useEffect } from 'react';

const Settings = () => {
    const { refetch } = useAuthContext();

    async function onReset() {
        window.location.replace('/settings');
    }

    useEffect(() => {
        refetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <section className='my-6 mx-1 md:mx-6 border-2 rounded-xl p-0.5 pb-12 shadow-lg space-y-6'>
            <div className='space-y-6 rounded-[10px] p-2 md:p-6'>
                <h1 className='font-bold text-fluid-h1 mb-8'>Settings</h1>
                <Separator />

                <AsyncErrorBoundary
                    showCancelButton={false}
                    onReset={onReset}>
                    <div className='flex flex-col lg:flex-row lg:items-center gap-2 !mb-16'>
                        <UserData />
                    </div>
                </AsyncErrorBoundary>
                <Separator />

                <AsyncErrorBoundary
                    showCancelButton={false}
                    onReset={onReset}>
                    <div className='flex flex-col lg:flex-row lg:items-center gap-2 !mb-16'>
                        <PrimaryEmail />
                    </div>
                </AsyncErrorBoundary>
                <Separator />

                <div className='min-h-64 flex flex-col lg:flex-row lg:items-center gap-2 !mb-16'>
                    <RecoveryEmail />
                </div>
                <Separator />

                <div className='flex flex-col lg:flex-row lg:items-start gap-2'>
                    <ChangePasswordForm />
                </div>

                <div className='flex flex-col items-center sm:items-start gap-2'></div>
            </div>
        </section>
    );
};
export default Settings;
